import {VGNav} from "vgnav";
import {VGLawCookie} from "vglawcookie";
import {CatalogCategories} from  "./CatalogCategories";
import { Fancybox } from "@fancyapps/ui";

window.VegasListener = {
	onReady: () => {
		Vegas.bg();
		Vegas.enablePlugins();
		Vegas.other();
		Vegas.enableLawCookie();
		Vegas.clones();
		Vegas.categories();
		Vegas.fixedHeader();
		Vegas.fancybox();
	},
	
	onLoad: () => {
		Vegas.preloader();
	},

	onClick: () => {
		Vegas.popup();
		Vegas.toggle();
	},
	
	onSubmit: () => {
		Vegas.forms();
	},
	
	onScroll: ($self) => {
		Vegas.fixedHeader();
	},
};

window.Vegas = {
	log: function () {
		console.group('vegas studio');
		console.log("%cvegas app was initialization", "color: green;");
		console.log('https://vegas-dev.com/');
		console.groupEnd();
	},
	
	preloader: function () {
	
	},

	fancybox: () => {
		Fancybox.bind("[data-fancybox]", {});
	},
	
	forms: function () {
		$('.form-vegas').vegasFormSender({
			beforeSend: function (form) {
				AlertFormSender.Action.beforeSend(form);
			},
			success: function (data, form) {
				AlertFormSender.Action.success(data.msg, form);
			},
			error: function (msg, form) {
				AlertFormSender.Action.error(msg, form);
			},
			validate: function (form, errors) {
				AlertFormSender.Action.validate(errors, form);
			}
		});
	},

	categories: function () {
		const categoriesMain = document.querySelector('.page-home--hero [data-catalog-categories-container]');
		const categoriesHeader = document.querySelector('.header [data-catalog-categories-container]');
		new CatalogCategories(categoriesMain);
		const headerCat = new CatalogCategories(categoriesHeader);
		headerCat.showCategories();
	},
	
	enablePlugins: function () {
		// niceSelect;
		$(".nice-select").niceSelect();
		
		// vegasMegaMenu
		new VGNav({
			expand: 'lg',
			toggle: '<i class="fa fa-chevron-down"></i>'
		});
		
		// Scrollbars
		//$('[class^="scroll-"], [class*="scroll-"]').overlayScrollbars({});
	},

	enableLawCookie: function () {
		new VGLawCookie({
			privacyLink: '/privacy-policy'
		});

	},

	clones: function () {
		if (window.innerWidth < 767) {
			// Навигация
			let $obj_nav_clone = $('.vg-nav-lg');
			if ($obj_nav_clone.length) {
				$obj_nav_clone.clone().detach();
				$('#vgnav-clone-area').append($obj_nav_clone);
			}
		}

		if (window.innerWidth < 992) {
			let $obj_filters_clone = $('.catalog-filters--clone');
			if ($obj_filters_clone.length) {
				$obj_filters_clone.clone(true).detach();
				$('.catalog-sidebar--clone-filters').append($obj_filters_clone)
			}
		}
	},
	
	toggle: function () {
		// $('[data-toggle=prd-image]').click(function () {
		// 	let $container = $('.vg-prd-image-toggle');
		// 	let $original = $container.find('.original');
		// 	let src = $(this).data('original');
		// 	let key = $(this).data('key');
		//
		// 	$container.find('.active').removeClass('active');
		// 	$(this).closest('.thumb').addClass('active');
		//
		// 	$original.find('a').attr('href', src).data('key', key);
		// 	$original.find('img').attr('src', src);
		//
		// 	return false;
		// });
		//
		// $('[data-toggle=prd-image-full]').click(function () {
		// 	let $container = $('.vg-prd-image-toggle');
		// 	let $thumbs = $container.find('.thumbs').find('[data-original]');
		// 	let thumbs = [];
		// 	let key = $(this).data('key');
		//
		// 	$.merge($thumbs.slice(key), $thumbs.slice(0, key)).each(function () {
		// 		let $_self = $(this),
		// 			src = $_self.data('original');
		//
		// 		thumbs.push({
		// 			src: src
		// 		});
		// 	});
		//
		// 	$.fancybox.open(thumbs, {
		// 		loop: true
		// 	});
		//
		// 	return false;
		// });
		
		$('body').find('[data-toggle=filters]').on('click', function () {
			let $self = $(this);
			let target = $self.attr('href');
			
			$(target).toggleClass('show');
			
			return false;
		});
	},
	
	popup: function () {
		$('[data-modal]').click(function () {
			let $target = $(this).data('modal'),
				id = $(this).data('id') || false,
				title = $(this).data('title') || false;
			
			if (title) {
				$($target).find('.modal-title').text(title);
			}
			
			if (id) {
				$($target).find('form input[name=id]').val(id);
			}
			
			$($target).modal('show');
			
			return false;
		});
	},
	
	bg: function () {
		let $bg = $('[data-bg]');
		if ($bg.length) {
			$bg.each(function () {
				let $self = $(this),
					bg = $self.data('bg'),
					repeat = $self.data('repeat') || 'no-repeat',
					position = $self.data('position') || 'center',
					size = $self.data('size') || 'cover',
					attachment = $self.data('attachment') || 'inherit';
				
				$self.css({
					'background-image': 'url(' + bg + ')',
					'background-position': position,
					'background-repeat': repeat,
					'background-size': size,
					'background-attachment': attachment
				});
			});
		}
	},
	
	other: function () {
		// page
		let $pageText = $('.page-default');
		$pageText.find('table').addClass('table table-hover table-striped');
		//$pageText.find('br').after('<span class="mb-15 d-block"></span>');
	},

	fixedHeader: function () {
		let $sticky = $('.header-wrapper'),
			headerHeight = $sticky.height(),
			$offset = headerHeight + 556,
			scroll = window.pageYOffset,
			searchContent = $('.search-area .search-content'),
			headerBottom = $('.header-bottom'),
			$body = $('body');

		if(headerHeight < scroll) {
			$sticky.addClass('scroll');
			searchContent.removeClass('focused');
			headerBottom.removeClass('show-categories')
		} else {
			$sticky.removeClass('scroll');
		}

		if (scroll > $offset) {
			$body.addClass('header--is-fixed');
			$sticky.addClass('fixed');
		} else {
			$sticky.removeClass('fixed');
			$body.removeClass('header--is-fixed');
		}
	},
};